import {Pipe, PipeTransform} from '@angular/core';
import {VatDto} from '../../../Models/Core/vat.interface';
import {LinesDto} from '../../../Models/Purchases/Shared/line.interface';

@Pipe({
  name: 'vatProducts',
  standalone: false
})
export class VatProductsPipe implements PipeTransform {

  transform(items: VatDto[], products: LinesDto[]): VatDto[] {

    if (items) {

      if (!products || products.length === 0) {
        return [];
      }

      return items.filter((vat) => products.some((product) => product.id_iva === vat.id));

    }

    return items;

  }

}
